<template>
  <div class="content">
    <div class="left">
      <div style="display: flex; flex-direction: column; margin-bottom: 30px">
        <span style="font-size: 24px; color: #333333; margin-bottom: 20px">{{
          $t("profile.passwordSetting")
        }}</span
        ><span style="font-size: 14px; color: #f5a623"
          ><i class="el-icon-info" style="margin-right: 8px"></i
          >{{ $t("profile.pswSettingDes") }}</span
        >
      </div>
      <div class="form">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('profile.oldPwd')" prop="oldPass">
            <el-input
              v-model="ruleForm.oldPass"
              type="password"
              autocomplete="off"
              :show-password="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('profile.newPwd')" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
              :show-password="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('profile.confrmPwd')" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
              :show-password="true"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">{{
              $t("main.submit")
            }}</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <div class="right">
      <div class="info">
        <img
          :src="avatarUrl"
          style="width: 80px; margin-left: 5px; margin-bottom: 20px"
          alt=""
        /><span style="font-size: 18px; color: #333333; margin-bottom: 20px">{{
          userInfo?.userName
        }}</span
        ><span style="font-size: 14px; color: #999999">{{
          userInfo?.deptName
        }}</span>
      </div>
      <div class="idNumber">
        <span style="margin-bottom: 12px"
          >{{ $t("profile.studentStaffID") }}：</span
        ><span>{{ $t("profile.phone") }}：{{ userInfo?.phone }}</span>
      </div>
    </div> -->
  </div>
</template>
<script>
import { getImageUrl } from "@/utils/imageHelper";
import request from "@/api/request";
import { encryptData } from "@/utils/encrypt";
export default {
  data() {
    var checkOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("profile.inputOldPwd")));
      } else {
        // if (this.ruleForm.oldPass !== "") {
        //   this.$refs.ruleForm.validateField("oldPass");
        // }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("profile.inputNewPwd")));
      } else if (value == this.ruleForm.oldPass) {
        callback(new Error(this.$t("profile.cannotBeSame")));
      }
      // 新增：密码长度校验（最短长度为 passLength）
      else if (this.passLength && value.length < this.passLength) {
        callback(new Error(`密码长度不能少于${this.passLength}位`));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("profile.inputPwdAgain")));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error(this.$t("profile.pwdNotSame")));
      } else {
        callback();
      }
    };
    return {
      avtor: require("@/assets/img/personal/avtor.png"),
      userInfo: {},
      ruleForm: {
        pass: "",
        checkPass: "",
        oldPass: "",
      },
      passLength: null,
      publicKey: "",
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        oldPass: [{ validator: checkOldPass, trigger: "blur" }],
      },
    };
  },
  computed: {
    // 计算属性方式
    avatarUrl() {
      return getImageUrl(this.avtor);
    },
  },
  created() {
    this.userInfo = {
      ...JSON.parse(localStorage.getItem("accountInfo"))?.data,
    };
    this.avtor = this.userInfo.avatar;
    const config = JSON.parse(localStorage.getItem("allConfig"));
    for (let i = 0; i < config.length; i++) {
      if (config[i].key == "user.password.length") {
        this.passLength = config[i].value;
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submit() {
      const config = JSON.parse(localStorage.getItem("allConfig"));
      for (let i = 0; i < config.length; i++) {
        if (config[i].name == "RSA公钥") {
          this.publicKey = config[i].value;
        }
      }
      const dataObj = {
        oldPassword: encryptData(this.ruleForm.oldPass, this.publicKey),
        newPassword: encryptData(this.ruleForm.pass, this.publicKey),
        encrypt: true,
      };
      request({
        url: "/api/user/update/pwd",
        method: "post",
        data: dataObj,
      })
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            this.$message.success(this.$t("profile.modifySuccess"));
            this.$refs.ruleForm.resetFields();
          }
        })
        .catch((error) => {});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  display: grid;
  grid-template-columns: 4fr 1.3fr;
  height: 600px;
  .left {
    // border-right: 1px solid #dfdfdf;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;
    .form {
      width: 60%;
    }
  }
  .right {
    background-image: url("@/assets/img/personal/editPassBg.png");
    background-size: contain;
    background-repeat: no-repeat;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20%;
    }
    .idNumber {
      display: flex;
      flex-direction: column;
      padding: 15px;
      font-size: 14px;
      color: #666666;
      background: #f5f7fb;
      border-radius: 4px;
      width: 80%;
      margin-top: 15px;
    }
  }
}
</style>
